import React from 'react'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import GenericStatusComponent from '../../genericComponents/GenericStatusComponent'
import GenericAvatarComponent from '../../genericComponents/GenericAvatarComponent'
import { MessageSquare, ChevronDown, Equal, ChevronsUp, AlertTriangle, User } from 'lucide-react'
import LanguageTranslator from '../../locals/LanguageTranslator'

dayjs.extend(relativeTime)

const PRIORITY_STYLE_MAP = {
    LOW: 'bg-[#EAF2FF] text-[#2969FF]',
    MEDIUM: 'bg-[#FFF4E0] text-[#B7791F]',
    HIGH: 'bg-[#FDEBEA] text-[#F04438]',
    URGENT: 'bg-[#FDEBEA] text-[#F04438]',
}

const PRIORITY_ICON_MAP = {
    LOW: ChevronDown,
    MEDIUM: Equal,
    HIGH: ChevronsUp,
    URGENT: AlertTriangle,
}

const TaskManagerListItem = (props) => {
    const { item, isActive, onClick } = props
    const PriorityIcon = PRIORITY_ICON_MAP[item.priority]

    const taskNo = item.task_number || item.taskNo || '..'
    const timeAgo = (item.created_at ? dayjs(item.created_at).fromNow() : item.timeAgo) || '..'
    const commentCount = item.commentCount || 0
    const isSystemCreated = String(item.created_by) === '-10'
    // Mentions are about who tagged you, not who the task is assigned by - never show "System" here.
    const isMention = !!item.mentionedByName
    const isUnreadMention = isMention && !!item.mentionUnread
    const assignedByName = isMention ? item.mentionedByName : (isSystemCreated ? 'System' : (item.assignedBy || '..'))
    const assigneeInitials = isMention ? (item.mentionedByInitials || '..') : (isSystemCreated ? 'SY' : (item.assigneeInitials || '..'))
    const actionText = isMention ? 'mentioned you' : (item.actionText || 'assigned you a task')

    const cardStateClass = isActive
        ? 'bg-primary_w_less_opacity border-l-primary'
        : isUnreadMention
            ? 'bg-[#F0F6FF] border-l-transparent hover:bg-[#E6F0FF]'
            : 'border-l-transparent hover:bg-[#F8FAFC]'

    return (
        <div
            onClick={onClick}
            className={`tmli-card px-4 py-3 border-b border-l-[3px] border-borderSlateGrey cursor-pointer ${cardStateClass}`}
        >
            <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2 min-w-0">
                    <GenericAvatarComponent name={assignedByName} initials={assigneeInitials !== '..' ? assigneeInitials : null} size={25}>
                        {assigneeInitials === '..' && <User size={14} />}
                    </GenericAvatarComponent>
                    <p className={`mb-0 text-[12px] text-fontBlack truncate ${isUnreadMention ? 'font-semibold' : ''}`}>
                        <span className="font-semibold">{assignedByName}</span> {actionText}
                    </p>
                </div>
                <GenericStatusComponent status={item.status} size="small" />
            </div>

            <p className="mb-1 text-[12px] font-semibold text-fontBlack">{item.title}</p>
            <p className="mb-2 text-[11px] text-fontSlateGrey leading-[18px]">{item.description}</p>

            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <span className="text-xs border border-borderSlateGrey rounded-[3px] px-2 py-0.5 text-fontBlack">{taskNo}</span>
                    <button type="button" className={`flex items-center gap-1 text-xs rounded-full px-2.5 py-1 font-medium ${PRIORITY_STYLE_MAP[item.priority]}`}>
                        {PriorityIcon && <PriorityIcon size={12} />}
                        <LanguageTranslator>{item.priority}</LanguageTranslator>
                    </button>
                </div>
                <span className="flex items-center gap-1.5 text-[10px] text-fontSlateGrey">
                    {isUnreadMention && <span className="h-1.5 w-1.5 rounded-full bg-primary shrink-0" />}
                    {timeAgo}
                </span>
            </div>

            {commentCount > 0 && (
                <div className="flex items-center gap-1 mt-2 text-[12px] text-fontSlateGrey">
                    <MessageSquare size={13} />
                    <span>{commentCount}+ comments</span>
                </div>
            )}
        </div>
    )
}

export default TaskManagerListItem
